const ACTIVITY_SESSION_ID_KEY = 'ACTIVITY_SESSION_ID';

export const getActivitySessionId = (): string | null => {
  if (typeof sessionStorage === 'undefined') return null;
  return sessionStorage.getItem(ACTIVITY_SESSION_ID_KEY);
};

export const setActivitySessionId = (sessionId: string): void => {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(ACTIVITY_SESSION_ID_KEY, sessionId);
};

export const clearActivitySessionId = (): void => {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(ACTIVITY_SESSION_ID_KEY);
};
